import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Header from '../Header';
import Footer from '../Footer';

import styles from './ThanksScreen.module.css';

import { ReactComponent as ArrowIcon } from '../../assets/img/arrow-right.svg';

const ThanksScreen = () => {

  const { config: { links } } = useSelector(state => state.config);

  const { formatMessage } = useIntl();

  return (
    <>
      <div className={styles['body-container']}>
        <div className={styles['header-container']}>
          <Header></Header>
        </div>
        <div className={`${styles['title']} Rubik-60pt`}>
          {formatMessage({id: 'ThanksScreen.title'})}
        </div>
        <div className={`${styles['subtitle']} Rubik-26pt`}>
          {formatMessage({id: 'ThanksScreen.text'})}
        </div>
        <div className={styles['links']}>
          <div className={styles['links_link']}>
            <a href={links.corporateWebsite} target="_blank" rel="noopener noreferrer">
              <ArrowIcon className={styles['link-icon']}/>
              <span className={`${styles['link-text']} Rubik-26pt`}>
                {formatMessage({id: 'ThanksScreen.corporateWebsite'})}
              </span>
            </a>
          </div>
          <div className={styles['links_link']}>
            <a href={links.solutions} target="_blank" rel="noopener noreferrer">
              <ArrowIcon className={styles['link-icon']}/>
              <span className={`${styles['link-text']} Rubik-26pt`}>
                {formatMessage({id: 'ThanksScreen.solutions'})}
              </span>
            </a>
          </div>
          <div className={styles['links_link']}>
            <Link to="/">
              <ArrowIcon className={styles['link-icon']}/>
              <span className={`${styles['link-text']} Rubik-26pt`}>
                {formatMessage({id: 'ThanksScreen.configurator'})}
              </span>
            </Link>
          </div>
        </div>
        <div className={styles['footer-container']}>
          <Footer></Footer>
        </div>
      </div>
    </>
  );
};

export default ThanksScreen;
